import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import ResultsTab from "./viewResultsComponents/ResultsTab/ResultsTab";
import TaskQuestionViewResultsTab from "./viewResultsComponents/TaskQuestionViewResultsTab/TaskQuestionViewResultsTab";
import PresentationTab from "./viewResultsComponents/PresentationTab/PresentationTab";
import SurveyTaskQuestionView from "./viewResultsComponents/TaskQuestionViewResultsTab/SurveyTaskQuestionView";
import SavedItemsTab from "./viewResultsComponents/SavedItemsTab/SavedItemsTab";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { decrypt } from "../../../utils/commonLogics";

const ViewResultsData = () => {
  const { panel_projects, token, user } = useSelector((state) => state.auth);
  const { studyId } = useSelector((state) => state.study);
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const tid = searchParams.get("tid");
  const study_id = studyId ? studyId : decrypt(searchParams.get("studyId"));
  const location = useLocation();
  const hostname = window.location.hostname;
  const match = location.pathname.match(/fromClient-(\d+)/);
  const clientId = match ? match[1] : null;
  const lastSegment = location.pathname.split("/").pop();
  const navigate = useNavigate();

  return (
    <div
      className="container-fluid page-wrapper"
      style={{ position: "relative" }}
    >
      <div className="row">
        <div className="col-12">
          <div className="card shadow-card">
            <div className="d-flex justify-content-between align-items-center p-3">
              <h6
                className="m-0 title fs-13"
                // onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                <span
                  className="pi pi-angle-left"
                  style={{ verticalAlign: "bottom" }}
                ></span>{" "}
                Back
              </h6>
            </div>
            <div
              style={{
                width: "100%",
                minHeight: "700px",
                border: "1px solid #ccc",
                position: "relative",
              }}
            >
              <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => {
                  setActiveIndex(e.index);
                }}
                className="xmot-results-tabs"
              >
                <TabPanel header="Results" className="tabStyle">
                  <ResultsTab
                    study_id={study_id}
                    token={token}
                    clientId={clientId}
                  />
                </TabPanel>
                <TabPanel header="Task/Question">
                  <TaskQuestionViewResultsTab />
                  {/* <SurveyTaskQuestionView /> */}
                </TabPanel>
                <TabPanel header="Saved Items">
                  <SavedItemsTab />
                </TabPanel>
                <TabPanel header="Presentation">
                  <PresentationTab />
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewResultsData;
